import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";

interface ComponentProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
    label: string;
}

function FormSelect({label, children, ...inputProps}: ComponentProps) {
    return (
        <div className="form-input-wrapper">
            <select
                {...inputProps}
                className="form-input form-select"
            >
                {children}
            </select>
            <label
                className="form-input-label"
                htmlFor={inputProps.id}>
                {label}
            </label>
            <div className="form-select-caret">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10">
                    <path d="M0 3h10L5 8"/>
                </svg>
            </div>
        </div>
    );
}

export default FormSelect;
